import React from 'react'
import { withRFSToken } from '../../Services/axios';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { DOWNLOADFILES } from '../../Utils/conts';

export const DownloadImage = async ( imageUrl, imageName ) => {
    console.log('imageUrl',imageUrl);
    
    function extractPath(url) {
      try {
        let urlObject = new URL(url);
        let path = urlObject.pathname.substring(1);
        return path;
      } catch (error) {
        console.error("Invalid URL:", error);
        return null;
      }
    };
    // const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken.post("get-file-blob", {file_path: imageUrl,})
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                toast.error("Could not download the file");
            });
    // };
    // return (
    //     <div>DownloadImage</div>
    // )
}

export const DownloadAllImage = async (payload, name) => {
    //   let payload = {};
    //   if (attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld') {
    //     payload = {
    //       uld_number: attachment_no,
    //       attachments: selectedRows
    //     }
    //   } else if (attachable_type == 'service_recovery' || attachable_type == 'service_recovery_handler_feedback') {
    //     payload = {
    //       service_recovery_id: attachable_id,
    //       attachments: selectedRows
    //     }
    //   } else {
    //     payload = {
    //       uld_number: attachable_id,
    //       attachments: selectedRows
    //     }
    //   }
      const res = await withRFSToken.post(DOWNLOADFILES, payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          responseType: 'blob', // important for handling binary file download like Excel
        }
      ).then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name ? `${name}.zip` : 'attachments.zip';
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.success("Downloaded Successfully");
      });
      // const res = await withRFSToken.post(DOWNLOADFILES, payload) // { uld_number: attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld' ? attachment_no : attachable_id, attachments: selectedRows, }
      //   .then(function (res) {
      //     if (res.data.response_code == 200) {
      //       const downloadUrl = res.data.response_data;
      //       const a = document.createElement("a");
      //       a.href = downloadUrl;
      //       a.download = "download.zip"; // You can set a default filename here
      //       document.body.appendChild(a);
      //       a.click();
      //       document.body.removeChild(a);
      //       toast.success("Downloaded Successfully");
      //     } else {
      //       toast.error(res.data.response_msg);
      //     }
      //   });
    };
